<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalElements"
      :loading="isSearching"
      item-key="id"
      locale="pt-BR"
      show-select
      class="elevation-3 mt-2"
    >
      <template v-slot:item.description="{item}">
        <acceptance-rule-descriptions
          :item="item"
          :acceptance-rule-descriptions="getAcceptanceRuleDescriptions"
          @on-description-created="updateAcceptanceRuleCarrier"
          class="mt-1 mb-1"
        >
        </acceptance-rule-descriptions>
      </template>
    </v-data-table>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </div>
</template>

<script>
import AcceptanceRuleCarrierService from '@/services/insurancepricing/AcceptanceRuleCarrierService';
import AcceptanceRuleDescriptions from '@/view/acceptance_rule/acceptance_rule_descriptions';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

export default {
  components: {AcceptanceRuleDescriptions, DlgConfirmCancel},
  props: {
    acceptanceRuleId: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        {text: 'CNPJ', value: 'carrier.cnpj'},
        {text: 'Nome Fantasia', value: 'carrier.name'},
        {text: 'Razão Social', value: 'carrier.razaoSocial'},
        {text: 'Descrição', value: 'description'},
      ],
      isSearching: false,
      options: {},
      items: [],
      totalElements: null,
      singleSelect: false,
      selected: [],
    };
  },
  async created() {
    this._service = new AcceptanceRuleCarrierService();
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('acceptanceRule', ['getAcceptanceRuleDescriptions']),
  },
  methods: {
    ...mapActions('acceptanceRule', ['fetchAcceptanceRuleDescriptions']),
    ...mapMutations(['toogleDialogLoading', 'showmsg']),
    async updateAcceptanceRuleCarrier(
      acceptanceRuleCarrier,
      acceptanceRuleDescriptionId,
    ) {
      const bodyFormData = new FormData();
      bodyFormData.append(
        'acceptanceRuleDescriptionId',
        acceptanceRuleDescriptionId,
      );
      await this._service.update(
        this.acceptanceRuleId,
        acceptanceRuleCarrier.id,
        bodyFormData,
      );
    },
    async loadData() {
      this.isSearching = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      this._service
        .findAllByAcceptanceRuleId(this.acceptanceRuleId, {
          page: page ? page - 1 : 0,
          sortBy:
            sortBy && sortBy.length
              ? sortBy[0] === 'account.carrierName'
                ? 'carrier.name'
                : sortBy[0]
              : 'carrier.razaoSocial',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
        })
        .then((res) => {
          this.items = res.data.content;
          this.totalElements = res.data.totalElements;
          this.isSearching = false;
          this.$emit('on-load');
        });

      if (!this.getAcceptanceRuleDescriptions.length) {
        this.fetchAcceptanceRuleDescriptions(this.acceptanceRuleId).then();
      }
    },
    async removeAll() {
      if (
        this.selected.length &&
        (await this.$refs.confirm.show(
          'Atenção',
          'Deseja excluir os registros selecionados?',
        ))
      ) {
        this.toogleDialogLoading(true);
        for (const acceptanceRulePlan of this.selected) {
          await this._service.delete(
            this.acceptanceRuleId,
            acceptanceRulePlan.id,
          );
        }
        this.showmsg({text: 'Operadores desassociados com sucesso!'});
        this.toogleDialogLoading(false);
        await this.loadData();
      }
    },
  },
};
</script>
